export const RequiredMark = () => <span className="text-kds-danger">*</span>;
